import { Icon } from "@iconify/react";
import "../styles/QuoteVehicleInfo.css";

function QuoteVehicleInfo({ quote }) {
  const vehicle = quote.vehicle;
  
  if (!vehicle) return null;

  return (
    <div className="quote-vehicle-card">
      <div className="quote-vehicle-header">
        <Icon icon="mdi:car" className="card-icon" />
        <h2 className="card-title">Informações do Veículo</h2>
      </div>

      <div className="quote-vehicle-content">
        <div className="vehicle-info-grid">
          {vehicle.plate && (
            <div className="vehicle-info-item">
              <Icon icon="mdi:card-text-outline" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Placa</span>
                <span className="info-value">{vehicle.plate}</span>
              </div>
            </div>
          )}

          {vehicle.brand && (
            <div className="vehicle-info-item">
              <Icon icon="mdi:car-side" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Marca</span>
                <span className="info-value">{vehicle.brand}</span>
              </div>
            </div>
          )}

          {vehicle.model && (
            <div className="vehicle-info-item">
              <Icon icon="mdi:car-info" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Modelo</span>
                <span className="info-value">{vehicle.model}</span>
              </div>
            </div>
          )}

          {vehicle.year && (
            <div className="vehicle-info-item">
              <Icon icon="mdi:calendar" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Ano</span>
                <span className="info-value">{vehicle.year}</span>
              </div>
            </div>
          )}

          {vehicle.color && (
            <div className="vehicle-info-item">
              <Icon icon="mdi:palette" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Cor</span>
                <span className="info-value">{vehicle.color}</span>
              </div>
            </div>
          )}

          {vehicle.armored_vehicle !== undefined && (
            <div className="vehicle-info-item">
              <Icon icon="mdi:shield-car" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Veículo Blindado</span>
                <span className="info-value">
                  {vehicle.armored_vehicle ? "Sim" : "Não"}
                </span>
              </div>
            </div>
          )}

          {vehicle.chassi && vehicle.chassi !== "undefined" && (
            <div className="vehicle-info-item">
              <Icon icon="mdi:identifier" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Chassi</span>
                <span className="info-value">{vehicle.chassi}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default QuoteVehicleInfo;
